import React, {Component} from "react";
import {Button} from "primereact/button";
import {Growl} from 'primereact/growl';
import {REG_EXP_EMAIL} from "../../../../utils/constants/Constants";
import SendConfirmationView from "./SendConfirmationView";
import {ReportsService} from "../../../../service/reports/ReportsService";

export default class SendConfirmationContainer extends Component {
    constructor(props) {
        super(props);
        this.getDataEmailPTM = this.getDataEmailPTM.bind(this);
        this.getDataEmailPTT = this.getDataEmailPTT.bind(this);
        this.reportsService = new ReportsService();

        this.state = {
            dataEmailsPTM: this.getDataEmailPTM(),
            dataEmailsPTT: this.getDataEmailPTT(),
            reportSelected: this.props.location.state.reportSelected,
            returnPath: this.props.location.state.returnPath,
            dataConfirmationEmails: [],
            confirmationData: {
                ptm: '',
                ptt: '',
                correoElectronico: '',
            },
            emailSelected: {},
            displayDialog: false,
            isLoading: false,
        };

        this.returnHistoricalReports = this.returnHistoricalReports.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.onChangeConfirmationData = this.onChangeConfirmationData.bind(this);
        this.addAditionalEmail = this.addAditionalEmail.bind(this);
        this.deleteEmail = this.deleteEmail.bind(this);
        this.handleSelectEmail = this.handleSelectEmail.bind(this);
        this.emailConfirmationActionTemplate = this.emailConfirmationActionTemplate.bind(this);
        this.openNewEmailDialog = this.openNewEmailDialog.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.loading = this.loading.bind(this);
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    getDataEmailPTM() {
        this.loading(true);
        let folioOperation = this.props.location.state.reportSelected.folioOperacion;
        this.reportsService.getEmailConfirmation('PTM', folioOperation)
            .then(resp => {
                    this.setState({
                        dataEmailsPTM: resp.payload,
                    });
                    this.loading(false);
                }
            );
    }

    getDataEmailPTT() {
        this.loading(true);
        let folioOperation = this.props.location.state.reportSelected.folioOperacion;
        this.reportsService.getEmailConfirmation('PTT', folioOperation)
            .then(resp => {
                    this.setState({
                        dataEmailsPTT: resp.payload,
                    });
                    this.loading(false);
                }
            );
    }

    returnHistoricalReports(message) {
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    sendEmail() {
        if (this.state.dataConfirmationEmails.length === 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: "Favor de agregar por lo menos un correo electrónico."
            });
        } else {
            this.loading(true);
            let emailListStr = '';
            this.state.dataConfirmationEmails.forEach(item => {
                emailListStr = emailListStr.concat(', ' + item.correoElectronico)
            });
            this.reportsService.sendHistoricalReport(emailListStr.substring(1),
                this.state.reportSelected.folioOperacion)
                .then(res => {
                    let messageObj = {};
                    if (res.message === "Success") {
                        messageObj['severity'] = 'success';
                        messageObj['sumary'] = 'Éxito';
                        messageObj['detail'] = 'El correo se ha enviado con exito';
                        this.returnHistoricalReports(messageObj);
                    } else if (res.error !== "") {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: res.error});
                    }
                    this.loading(false);
                });
        }
    }

    onChangeConfirmationData(event) {
        const {name} = event.target;
        let confirmationDataAux = this.state.confirmationData;
        let dataConfEmails = this.state.dataConfirmationEmails;
        let id = dataConfEmails.length === 0 ? 0 :
            dataConfEmails[dataConfEmails.length - 1]['id'] + 1;

        switch (name) {
            case 'ptm':
                confirmationDataAux[name] = event.target.checked;
                if (event.target.checked) {
                    dataConfEmails = dataConfEmails.concat(this.state.dataEmailsPTM.map((value, index) => {
                        value['id'] = id + index;
                        return value;
                    }));
                } else {
                    dataConfEmails = dataConfEmails.filter(email => email['rol'] !== 'Prestamista')
                }
                break;
            case 'ptt':
                confirmationDataAux[name] = event.target.checked;
                if (event.target.checked) {
                    dataConfEmails = dataConfEmails.concat(this.state.dataEmailsPTT.map((value, index) => {
                        value['id'] = id + index;
                        return value;
                    }));
                } else {
                    dataConfEmails = dataConfEmails.filter(email => email['rol'] !== 'Prestatario')
                }
                break;
            default:
                confirmationDataAux[name] = event.target.value;
                break;
        }
        this.setState({
            confirmationData: confirmationDataAux,
            dataConfirmationEmails: dataConfEmails,
        })
    }

    addAditionalEmail() {
        if (REG_EXP_EMAIL.test(this.state.confirmationData.correoElectronico)) {
            let dataEmails = this.state.dataConfirmationEmails;
            let id = dataEmails.length === 0 ? 0 :
                dataEmails[dataEmails.length - 1]['id'] + 1;
            dataEmails.push({
                correoElectronico: this.state.confirmationData.correoElectronico,
                rol: "Adicional",
                id: id
            });
            this.setState({
                dataConfirmationEmails: dataEmails,
            });
            this.onHideDialog();
        } else {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Correo no válido.'
            });
        }
    }

    openNewEmailDialog() {
        let confirmationDataAux = this.state.confirmationData;
        confirmationDataAux['correoElectronico'] = '';
        this.setState({
            confirmationData: confirmationDataAux,
            displayDialog: true,
        });
    }

    onHideDialog() {
        this.setState({displayDialog: false});
    }

    deleteEmail(rowData) {
        let emailSelectedAux = rowData;
        let dataConfEmails = this.state.dataConfirmationEmails;
        dataConfEmails = dataConfEmails.filter(val =>
            val.id !== emailSelectedAux.id);
        this.setState({dataConfirmationEmails: dataConfEmails})
    }

    emailConfirmationActionTemplate(rowData, column) {
        return (<Button label="Eliminar"
                        onClick={() => this.deleteEmail(rowData)}
                        className="p-button-secondary"/>);
    }

    handleSelectEmail = (event) => {
        this.setState({
            emailSelected: event.value,
        });
    };

    render() {
        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Agregar Correo Adicional</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Regresar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Guardar" onClick={this.addAditionalEmail}/>
                </div>
            </div>;

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        const {
            displayDialog, isLoading, confirmationData, emailSelected,
            dataConfirmationEmails
        } = this.state;

        return <SendConfirmationView confirmationData={confirmationData}
                                     emailSelected={emailSelected}
                                     dataConfirmationEmails={dataConfirmationEmails}
                                     dialogHeader={dialogHeader}
                                     displayDialog={displayDialog}
                                     isLoading={isLoading}
                                     messagesGrowl={messagesGrowl}
                                     returnHistoricalReports={this.returnHistoricalReports}
                                     handleSelectEmail={this.handleSelectEmail}
                                     openNewEmailDialog={this.openNewEmailDialog}
                                     onHideDialog={this.onHideDialog}
                                     onChangeConfirmationData={this.onChangeConfirmationData}
                                     emailConfirmationActionTemplate={this.emailConfirmationActionTemplate}
                                     sendEmail={this.sendEmail}
        />
    }
};